<template>
  <Modal appear variant="tutorial" :notCloseBg="false" @close="close">
    <template slot="content">
      <div class="p-tutorial">
        <transition name="v-fade" mode="out-in">
          <div v-if="splash.isActive" key="splash" class="p-tutorial-splash">
            <h2 class="p-tutorial-splash__title">
              <img
                src="@/assets/img/logo-wh.svg"
                width="367"
                height="42"
                alt="SEARCH WRITE"
              />
            </h2>
            <div class="p-tutorial-splash__text">
              <p>
                必要な機能だけのシンプル設計。<br />さぁ、SEO対策を始めましょう。
              </p>
            </div>
            <div class="p-tutorial-splash__image">
              <img src="@/assets/img/tutorial/img-tutorial00.png" alt="" />
            </div>
            <p class="p-tutorial-splash__feature">
              <img
                src="@/assets/img/tutorial/txt-tutorial00.png"
                alt="シンプルで使いやすい！"
              />
            </p>
          </div>
          <div v-else key="slider" class="p-tutorial-slider">
            <transition name="v-fade" mode="out-in">
              <div
                v-if="slider.current === 0"
                :key="0"
                class="p-tutorial-slider__item"
              >
                <div class="p-tutorial-slider__image">
                  <img src="@/assets/img/tutorial/img-tutorial01.png" alt="" />
                </div>
                <div class="p-tutorial-slider__page">
                  <img src="@/assets/img/tutorial/txt-tutorial01.png" alt="" />
                </div>
                <div class="p-tutorial-slider__content">
                  <h2 class="p-tutorial-slider__title">
                    サイト全体の指標を確認
                  </h2>
                  <div class="p-tutorial-slider__text">
                    <p>
                      <span class="c-text--main">GA・GSCデータサマリー</span
                      >ではサイト運用上の重要指標をチェック。<br />「指名・一般キーワード」を設定し、サイトのブランディング指標に。
                    </p>
                  </div>
                </div>
              </div>
              <div
                v-else-if="slider.current === 1"
                :key="1"
                class="p-tutorial-slider__item"
              >
                <div class="p-tutorial-slider__image">
                  <img src="@/assets/img/tutorial/img-tutorial02.png" alt="" />
                </div>
                <div class="p-tutorial-slider__page">
                  <img src="@/assets/img/tutorial/txt-tutorial02.png" alt="" />
                </div>
                <div class="p-tutorial-slider__content">
                  <h2 class="p-tutorial-slider__title">
                    惜しいキーワードをチェック
                  </h2>
                  <div class="p-tutorial-slider__text">
                    <p>
                      <span class="c-text--main">自社キーワード分析</span
                      >では、表示回数と順位を軸に、クリック率をバブルチャート分析。ポテンシャルワードを探しましょう。
                    </p>
                  </div>
                </div>
              </div>
              <div
                v-else-if="slider.current === 2"
                :key="2"
                class="p-tutorial-slider__item"
              >
                <div class="p-tutorial-slider__image">
                  <img src="@/assets/img/tutorial/img-tutorial03.png" alt="" />
                </div>
                <div class="p-tutorial-slider__page">
                  <img src="@/assets/img/tutorial/txt-tutorial03.png" alt="" />
                </div>
                <div class="p-tutorial-slider__content">
                  <h2 class="p-tutorial-slider__title">
                    重要キーワードは定点観測
                  </h2>
                  <div class="p-tutorial-slider__text">
                    <p>
                      <span class="c-text--main">検索順位チェック</span
                      >では、サイトに重要なキーワードとページのURLを設定して順位を定点的に観測できます。
                    </p>
                  </div>
                </div>
              </div>
              <div
                v-else-if="slider.current === 3"
                :key="3"
                class="p-tutorial-slider__item"
              >
                <div class="p-tutorial-slider__image">
                  <img src="@/assets/img/tutorial/img-tutorial04.png" alt="" />
                </div>
                <div class="p-tutorial-slider__page">
                  <img src="@/assets/img/tutorial/txt-tutorial04.png" alt="" />
                </div>
                <div class="p-tutorial-slider__content">
                  <h2 class="p-tutorial-slider__title">
                    ページのSEO評価と課題をチェック
                  </h2>
                  <div class="p-tutorial-slider__text">
                    <p>
                      <span class="c-text--main">SEO課題チェック</span
                      >では、検索傾向やトレンド把握、ページの状態、評価、SEO課題をじっくり分析。発見した課題に対するアドバイスも。
                    </p>
                  </div>
                </div>
              </div>
              <div
                v-else-if="slider.current === 4"
                :key="4"
                class="p-tutorial-slider__item"
              >
                <div class="p-tutorial-slider__image">
                  <img src="@/assets/img/tutorial/img-tutorial05.png" alt="" />
                </div>
                <div class="p-tutorial-slider__page">
                  <img src="@/assets/img/tutorial/txt-tutorial05.png" alt="" />
                </div>
                <div class="p-tutorial-slider__content">
                  <h2 class="p-tutorial-slider__title">
                    競合キーワードを調査
                  </h2>
                  <div class="p-tutorial-slider__text">
                    <p>
                      <span class="c-text--main">新規キーワード発見</span
                      >で競合調査。自社と競合のサイト順位・流入数を比較して、新しいコンテンツ立案のヒントにしましょう。
                    </p>
                  </div>
                </div>
              </div>
            </transition>

            <Checkbox id="never" name="never" v-model="checked">
              今後このメッセージを表示しない
            </Checkbox>
            <div class="p-tutorial-pagination">
              <div class="p-tutorial-pages">
                <div
                  v-for="n in slider.total"
                  :key="n"
                  class="p-tutorial-pages__item"
                  :class="{ 'is-active': n === slider.current + 1 }"
                  @click="slideIndex(n - 1)"
                >
                  {{ n }}
                </div>
              </div>
              <transition name="v-fade">
                <Button
                  v-if="slider.current > 0"
                  variant="light"
                  size="w100"
                  class="p-tutorial-pagination__prev"
                  @click="slidePrev"
                >
                  <Icon2 variant="arrow" :size="9" />
                  戻る
                </Button>
              </transition>
              <transition name="v-fade" mode="out-in">
                <Button
                  v-if="slider.current < slider.total - 1"
                  key="next"
                  variant="main"
                  size="w100"
                  class="p-tutorial-pagination__next"
                  @click="slideNext"
                >
                  次へ
                  <Icon2 variant="arrow" :size="9" />
                </Button>
                <template v-else>
                  <Button
                    v-if="!projectId"
                    key="start"
                    variant="main"
                    size="w100"
                    class="p-tutorial-pagination__start"
                    @click="close"
                  >
                    閉じる
                  </Button>
                  <Button
                    v-else
                    key="start"
                    variant="main"
                    size="w100"
                    class="p-tutorial-pagination__start"
                    @click="start"
                  >
                    開始
                    <Icon2 variant="arrow" :size="9" />
                    <Tooltip variant="btn">
                      まずは、キーワード登録
                    </Tooltip>
                  </Button>
                </template>
              </transition>
            </div>
          </div>
        </transition>
      </div>
    </template>
  </Modal>
</template>

<script>
import Button from '@/components/Button';
import Checkbox from '@/components/Checkbox';
import Icon2 from '@/components/Icon2';
import Modal from '@/components/Modal';
import Tooltip from '@/components/Tooltip';

export default {
  props: {
    projectId: {
      type: String,
      required: false
    }
  },
  components: {
    Button,
    Checkbox,
    Icon2,
    Modal,
    Tooltip
  },

  data() {
    return {
      checked: false,
      slider: {
        current: 0,
        total: 5
      },
      splash: {
        duration: 4000,
        timeout: null,
        isActive: true
      }
    };
  },

  mounted() {
    this.splash.timeout = setTimeout(() => {
      this.splash.isActive = false;
    }, this.splash.duration);
  },

  destroyed() {
    clearTimeout(this.splash.timeout);
  },

  methods: {
    close() {
      this.$emit('close', this.checked);
    },
    slideIndex(index) {
      this.slider.current = index;
    },
    slideNext() {
      this.slider.current++;
    },
    slidePrev() {
      this.slider.current--;
    },
    start() {
      this.close();
      this.$router.push({
        name: 'siteImportantKeyword',
        params: { projectId: this.projectId },
        query: { status: 'add' }
      });
    }
  }
};
</script>
